import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const PendingReview = new StatusEnumItem({
  id: '44C97685-CC34-4C36-A599-125F438C4C39',
  name: 'Pending Review',
  description:
    'The Identified Field Issue has been imported and is awaiting review',
  priority: 0,
})

const Closed = new StatusEnumItem({
  id: 'F84A95E1-CAE5-453B-91A4-F9C0428D28F3',
  name: 'Closed',
  description:
    'The Identified Field Issue has been reviewed. A new Issue may have been created from it',
  priority: 1,
})

export type IFIStatusItem = typeof PendingReview | typeof Closed

class IFIStatusEnum extends StatusEnum<
  'IFIStatus',
  IFIStatusItem,
  IFIStatusItem['name'],
  IFIStatusItem['id'],
  IFIStatusItem['priority']
> {
  readonly typename = 'IFIStatus'
  get values() {
    return [this.PendingReview, this.Closed]
  }
  readonly PendingReview = PendingReview
  readonly Closed = Closed
}

export const IFIStatus = new IFIStatusEnum()
